import groq from 'groq'
import { ButtonQuery } from '../atoms/ButtonQuery'



export const JobQuery = groq`
    _type == "JobType" => {
     ...,
     "jobs": *[count(_type == "job")]{
      "slug": slug.current,
        title,
        location,
        deadline,
        startDate,
        position
      },
    }
`
